import {
    AVAILABLE_PERIPHERIES_REQUEST_START,
    AVAILABLE_PERIPHERIES_REQUEST_SUCCESS,
    AVAILABLE_PERIPHERIES_REQUEST_ERROR,
} from 'state/actions/available_peripheries'


const defaultState = {
    ids: [],
    isLoading: false,
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case AVAILABLE_PERIPHERIES_REQUEST_START: {
        return {
            ...state,
            isLoading: true,
        }
    }
    case AVAILABLE_PERIPHERIES_REQUEST_SUCCESS: {
        return {
            ...state,
            isLoading: false,
            ids: action.payload,
        }
    }
    case AVAILABLE_PERIPHERIES_REQUEST_ERROR: {
        return {
            ...state,
            isLoading: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/available_peripheries.js